import * as React from 'react';
import { Chip } from "@mui/material"
import Grid from "@mui/material/Grid2"
import { Box } from "@mui/system"
import dayjs from "dayjs"
import UserAvatar from "../UserAvatar";
import { customer_user_object } from '../../Constants';
import { findUser, useUsers } from '../ReactQuery/QueryUsers';
import { useTrackedDarkMode } from '../UserState';

const SERVICE_ORDER_EVENT_FRIENDLY_NAMES = {
    "CREATION": "Create New Service Order",
    "STARTWORKSERVICEORDER": "Start Work",
    "STOPWORKSERVICEORDER": "Stop Work",
    "CHANGESERVICEORDERSTATUS": "Change Status",
    "UPDATESERVICEORDERSUMMARYNOTES": "Update Summary Notes",
    "UPDATESERVICEORDERPREFERREDPHONE": "Update Preferred Phone",
    "UPDATESERVICEORDERPREFERREDEMAIL": "Update Preferred Email",
    "UPDATECUSTOMER": "Update Customer",
    "SENDCUSTOMERMESSAGE": "Send Customer Message",
    "CHANGESERVICEORDERCUSTOMERAPPROVALSTATUS": "Change Customer Approval",
    "UPDATESERVICEORDERCURRENTLOCATION": "Update Current Location",
    "CUSTOMERCHANGESERVICEORDERCUSTOMERAPPROVALSTATUS": "Change Customer Approval",
    "ADDSERVICE": "Add Service",
    "REMOVESERVICE": "Remove Service",
    "CHANGESERVICEORDERSERVICESTATUS": "Change Service Status",
    "CHANGESERVICEORDERSERVICECUSTOMERAPPROVALSTATUS": "Change Service Customer Approval",
    "CUSTOMERCHANGESERVICEORDERSERVICECUSTOMERAPPROVALSTATUS": "Change Service Customer Approval",
    "UPDATESERVICEORDERSERVICESUMMARYNOTES": "Update Service Summary Notes",
    "UPDATESERVICEORDERSERVICENAME": "Update Service Name",
    "ADDPART": "Add Part",
    "INSTALLPART": "Install Part", // Deprecated
    "EDITPART": "Edit Part",
    "CHANGEPARTSTATUS": "Change Part Status",
    "REMOVEPART": "Remove Part",
    "CHANGESERVICEORDERASSIGNEE": "Change Assignee",
    "UPLOADFILE": "Upload File",
    "DELETEFILE": "Delete File",
    "SUBMITPAYMENTCALCULATIONS": "Update Invoice Calculations",
    "COMPLETESERVICEORDER": "Complete Service Order",
    "REVERTFROMINVOICED": "Reverted the Invoiced status",
    "REOPENSERVICEORDER": "Reopen Service Order",
    "SUBMITQUOTECALCULATIONS": "Submit Quote Calculations",
    "SENDQUOTE": "Send Quote",
    "SENDINVOICE": "Send Invoice",
    "CREATEWARRANTYCLAIM": "Create Warranty Claim",
    "UPDATEWARRANTYCLAIM": "Update Warranty Claim",
    "ADDSERVICETOWARRANTYCLAIM": "Add Service To Warranty Claim",
    "ADDPARTTOWARRANTYCLAIM": "Add Part To Warranty Claim",
    "ADDCHARGETOWARRANTYCLAIM": "Add Charge To Warranty Claim",
    "CREATEWORKHISTORY": "Create Work History",
    "EDITWORKHISTORY": "Edit Work History",
}

export const get_service_event_text = (serviceEvent) => {
    if (serviceEvent.event_type === 'CHANGEPARTSTATUS') {
        return `Changed part ${serviceEvent.service_order_part?.name ?? serviceEvent.service_order_part?.description ?? serviceEvent.service_order_part?.sku} status from ${serviceEvent.prev_status || 'N/A'} to ${serviceEvent.new_status}`
    } else {
        return serviceEvent.description
    }
}


export default function ServiceEvent({ serviceEvent }) {
    const { data: users, } = useUsers();
    const [darkMode,] = useTrackedDarkMode();
    const user = serviceEvent.user_id ? findUser(users, serviceEvent.user_id) : customer_user_object
    return (<Box key={serviceEvent.id} sx={{ mb: 1 }}>
        <Grid container space={1} sx={{ fontSize: '16px', fontWeight: 'bold' }}>
            <Grid size="auto">
                <span>{dayjs.utc(serviceEvent.date_created).local().format('M/D/YYYY h:mm A')}</span>
            </Grid>
            <Grid size="auto" sx={{ pr: 1, pl: 1 }}>
                <UserAvatar user={user} sx={{ height: '24px', width: '24px', fontSize: '0.9rem' }} />
            </Grid>
            <Grid size="auto">
                <span>{user?.name}</span>
            </Grid>
        </Grid>
        <Box sx={{ 'whiteSpace': 'pre-wrap', m: 1, p: 0.5, bgcolor: `backgroundColor.${darkMode ? 'light' : 'dark'}`, borderRadius: "8px 8px 0 0" }}>
            <span onClick={() => console.log(serviceEvent.request_body)}><Chip sx={{ fontWeight: 'bold' }} label={SERVICE_ORDER_EVENT_FRIENDLY_NAMES[serviceEvent.event_type]} color={"grey"} /> {get_service_event_text(serviceEvent)}</span>
        </Box>
    </Box>)
}